import React, { useEffect, useState } from "react";
import { getFacilities } from "../../../api/admin/facility";
import AddButton from "../../../components/admin/usable/AddButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import CancelButton from "../../../components/admin/usable/CancelButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setForAll,
  setIsSingleSelected,
  setShowFileUploader,
  setSingleSelected,
} from "../../../redux/admin/fileManagerSlice";
import FileUploadandSelect from "../../../components/admin/usable/fileuploader/FileUploadandSelect";
import Switch from "@mui/joy/Switch";
import EditorJSSingle from "../../../components/admin/usable/EditorJSSingle";
import CompanySelect from "../../../components/admin/usable/CompanySelect";
import toast from "react-hot-toast";
import { addHotel } from "../../../api/admin/hotel";
import { useNavigate } from "react-router";

const DuplicateHotel = () => {
  const navigate = useNavigate();
  const { duplicateData } = useSelector((state) => state.duplicateHotel);
  const [FormData, setFormData] = useState({
    companyId: "",
    hotelName: "",
    hotelLogo: "",
    propertyStar: "",
    description: "",
    rooms: "",
    floors: "",
    foundedYear: "",
    area: "",
    city: "",
    division: "",
    country: "",
    isCoupleFriendly: 0,
    isFeatured: 0,
    isIdRequired: 0,
    checkIn: "",
    checkOut: "",
    isChildAllowed: 1,
    childPolicy: "",
    isPetAllowed: 0,
    petPolicy: "",
    hotelRules: "",
    isAcceptMasterCard: 0,
    isAcceptVisaCard: 0,
    isAcceptAmmexCard: 0,
    isAcceptDebitCard: 0,
    isAcceptCash: 0,
    isAcceptsMFS: 0,
    isDhoorbinChoice: 0,
    isCustomerChoice: 0,
    status: 1,
    advancePayment: 0,
    created_by: 6,
    createdAt: new Date().toISOString(),
    facilities: [],
    images: [],
    nearBy: [],
    countryId: null,
    divisionId: null,
    cityId: null,
  });
  const [CompanyId, setCompanyId] = useState("");
  const [FacilityData, setsetFacilityData] = useState([]);
  useEffect(() => {
    getFacilities(setsetFacilityData);
  }, []);
  const [SelectedFacility, setSelectedFacility] = useState({
    useFor: "",
    facilities: [],
  });
  const [SelectNearBy, setSelectNearBy] = useState({
    placeName: "",
    description: "",
    image: "",
    distance: "",
    neighbourhood: "",
    neighbourhoodId: "",
  });
  const [ImageFile, setImageFile] = useState([]);
  const { showFileUploader, singleSelected, multiSelected } = useSelector(
    (state) => state.file,
  );
  const [activeUploadField, setActiveUploadField] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setForAll(true));
    dispatch(setIsSingleSelected(true));

    return () => {
      dispatch(setForAll(false));
      dispatch(setIsSingleSelected(false));
    };
  }, [dispatch]);
  useEffect(() => {
    if (singleSelected && activeUploadField === "hotelLogo") {
      setFormData((prevData) => ({
        ...prevData,
        [activeUploadField]: singleSelected.fileLink.medium || "",
      }));
      setActiveUploadField(null);
      dispatch(setSingleSelected(null));
    } else if (singleSelected && activeUploadField === "image") {
      setSelectNearBy((prevData) => ({
        ...prevData,
        [activeUploadField]: singleSelected?.fileLink?.medium || "",
      }));
    }
  }, [singleSelected, activeUploadField, dispatch]);
  useEffect(() => {
    if (multiSelected && multiSelected.length > 0) {
      const newImages = multiSelected.map((item) => ({
        imageLink: item.fileLink.medium,
      }));

      setFormData((prev) => {
        const existingLinks = prev.images.map((img) => img.imageLink);

        const merged = [
          ...prev.images,
          ...newImages.filter((img) => !existingLinks.includes(img.imageLink)),
        ];

        return {
          ...prev,
          images: merged,
        };
      });

      setImageFile((prev) => {
        const existingLinks = prev.map((img) => img.imageLink);
        return [
          ...prev,
          ...newImages.filter((img) => !existingLinks.includes(img.imageLink)),
        ];
      });
    }
  }, [multiSelected]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      images: ImageFile,
    }));
  }, [ImageFile]);

  const handleUpload = (field) => {
    setActiveUploadField(field);
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };
  const handleUseForChange = (e) => {
    setSelectedFacility((prev) => ({
      ...prev,
      useFor: e.target.value,
    }));
  };
  const handleSelectFacilities = (item) => {
    setSelectedFacility((prev) => {
      const alreadyExists = prev.facilities.some(
        (f) => f.facilityId === item.id,
      );

      return {
        ...prev,
        facilities: alreadyExists
          ? prev.facilities.filter((f) => f.facilityId !== item.id)
          : [
              ...prev.facilities,
              {
                facilityId: item.id,
                icon: item.icon,
                facilityName: item.facilityName,
              },
            ],
      };
    });
  };
  const handleSelectedFacility = () => {
    setFormData((prev) => {
      const existingIndex = prev.facilities.findIndex(
        (f) => f.useFor === SelectedFacility.useFor,
      );

      let updatedFacilities = [...prev.facilities];

      if (existingIndex !== -1) {
        updatedFacilities[existingIndex] = SelectedFacility;
      } else {
        updatedFacilities.push(SelectedFacility);
      }

      return {
        ...prev,
        facilities: updatedFacilities,
      };
    });

    setSelectedFacility({
      useFor: "",
      facilities: [],
    });
  };

  const handleFacilityEdit = (item) => {
    setSelectedFacility({
      useFor: item.useFor,
      facilities: item.facilities,
    });
  };
  const handleFacilityDelete = (item) => {
    setFormData((prev) => ({
      ...prev,
      facilities: prev.facilities.filter((f) => f.useFor !== item.useFor),
    }));
  };
  const handleRemoveImage = (name) => {
    if (name === "hotelLogo") {
      setFormData((prevData) => ({
        ...prevData,
        hotelLogo: "",
      }));
    } else {
      setSelectNearBy((prevData) => ({
        ...prevData,
        image: "",
      }));
    }
  };

  const handleNearByChange = (e) => {
    const { id, value } = e.target;
    setSelectNearBy((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const handleSelectedNearBy = () => {
    setFormData((prev) => {
      const existingIndex = prev.nearBy.findIndex(
        (f) => f.placeName === SelectNearBy.placeName,
      );

      let updateNearBy = [...prev.nearBy];

      if (existingIndex !== -1) {
        updateNearBy[existingIndex] = SelectNearBy;
      } else {
        updateNearBy.push(SelectNearBy);
      }

      return {
        ...prev,
        nearBy: updateNearBy,
      };
    });

    setSelectNearBy({
      placeName: "",
      description: "",
      image: "",
      distance: "",
      neighbourhood: "",
      neighbourhoodId: "",
    });
  };

  const handleChangeFeatures = (field) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: prevData[field] === 1 ? 0 : 1,
    }));
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      companyId: CompanyId,
    }));
  }, [CompanyId]);
  const handleUploadMulti = () => {
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };
  const handleRemoveImageLink = (link) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((img) => img.imageLink !== link),
    }));

    setImageFile((prev) => prev.filter((img) => img.imageLink !== link));
  };
  const handleRemoveNearbyPlaces = (link) => {
    setFormData((prev) => ({
      ...prev,
      nearBy: prev.nearBy.filter((pl) => pl.placeName !== link),
    }));
  };
  const handleEditNearByPlaces = (item) => {
    setSelectNearBy({
      placeName: item.placeName,
      description: item.description,
      image: item.image,
      distance: item.distance,
      neighbourhood: item.neighbourhood,
    });
  };
  const handleSubmit = () => {
    if (
      FormData.companyId === "" ||
      FormData.hotelName === "" ||
      FormData.hotelLogo === "" ||
      FormData.propertyStar === "" ||
      FormData.description === "" ||
      FormData.rooms === "" ||
      FormData.floors === "" ||
      FormData.foundedYear === "" ||
      FormData.area === "" ||
      FormData.city === "" ||
      FormData.division === "" ||
      FormData.country === "" ||
      FormData.isCoupleFriendly === "" ||
      FormData.isFeatured === "" ||
      FormData.isIdRequired === "" ||
      FormData.checkIn === "" ||
      FormData.checkOut === "" ||
      FormData.isChildAllowed === "" ||
      FormData.isPetAllowed === "" ||
      FormData.isAcceptMasterCard === "" ||
      FormData.isAcceptVisaCard === "" ||
      FormData.isAcceptAmmexCard === "" ||
      FormData.isAcceptDebitCard === "" ||
      FormData.isAcceptCash === "" ||
      FormData.isAcceptsMFS === "" ||
      FormData.isDhoorbinChoice === "" ||
      FormData.isCustomerChoice === "" ||
      FormData.status === "" ||
      FormData.advancePayment === 0 ||
      FormData.created_by === "" ||
      FormData.createdAt === "" ||
      FormData.facilities.length === 0 ||
      FormData.images.length === 0
    ) {
      toast.error("Fill up all the fields");
    } else {
      addHotel(FormData, navigate);
    }
  };
  useEffect(() => {
    if (duplicateData) {
      setFormData({
        companyId: duplicateData.companyId,
        hotelName: duplicateData.hotelName,
        hotelLogo: duplicateData.hotelLogo,
        propertyStar: duplicateData.propertyStar,
        description: duplicateData.description,
        rooms: duplicateData.rooms,
        floors: duplicateData.floors,
        foundedYear: duplicateData.foundedYear,
        area: duplicateData.area,
        city: duplicateData.city,
        division: duplicateData.division,
        country: duplicateData.country,
        isCoupleFriendly: duplicateData.isCoupleFriendly,
        isFeatured: duplicateData.isFeatured,
        isIdRequired: duplicateData.isIdRequired,
        checkIn: duplicateData.checkIn,
        checkOut: duplicateData.checkOut,
        isChildAllowed: duplicateData.isChildAllowed,
        childPolicy: duplicateData.childPolicy,
        isPetAllowed: duplicateData.isPetAllowed,
        petPolicy: duplicateData.petPolicy,
        hotelRules: duplicateData.hotelRules,
        isAcceptMasterCard: duplicateData.isAcceptMasterCard,
        isAcceptVisaCard: duplicateData.isAcceptVisaCard,
        isAcceptDebitCard: duplicateData.isAcceptDebitCard,
        isAcceptAmmexCard: duplicateData.isAcceptAmmexCard,
        isAcceptCash: duplicateData.isAcceptCash,
        isAcceptsMFS: duplicateData.isAcceptsMFS,
        isDhoorbinChoice: duplicateData.isDhoorbinChoice,
        isCustomerChoice: duplicateData.isCustomerChoice,
        status: duplicateData.status,
        advancePayment: duplicateData.advancePayment,
        created_by: duplicateData.created_by,
        createdAt: duplicateData.createdAt,
        facilities: duplicateData.facilities,
        images: duplicateData.images,
        nearBy: duplicateData.nearBy,
        countryId: duplicateData.countryId,
        divisionId: duplicateData.divisionId,
        cityId: duplicateData.cityId,
      });
      setImageFile(duplicateData.images);
      setCompanyId(duplicateData.companyId);
    }
  }, [duplicateData]);
  return (
    <>
      {showFileUploader && <FileUploadandSelect />}
      <div className="space-y-10">
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Hotel Information</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-3 gap-4">
            <div className="space-y-2">
              <div>
                <label className="text-xs" htmlFor="">
                  Company Name
                </label>
                <CompanySelect
                  CompanyId={CompanyId}
                  setCompanyId={setCompanyId}
                />
              </div>
              <div className="grid grid-col-1 lg:grid-cols-2 gap-2">
                <div>
                  <label className="text-xs" htmlFor="">
                    Area
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Area"
                    id="area"
                    value={FormData.area}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    City
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="City"
                    id="city"
                    value={FormData.city}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Division
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Division"
                    id="division"
                    value={FormData.division}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Country
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Country"
                    id="country"
                    value={FormData.country}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div>
              <div>
                <label className="text-xs" htmlFor="">
                  Hotel Name
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  placeholder="Hotel Name"
                  id="hotelName"
                  value={FormData.hotelName}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Description
                </label>
                <textarea
                  rows={5}
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  placeholder="Description"
                  id="description"
                  value={FormData.description}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Advance Payment
                </label>
                <input
                  type="number"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  placeholder="Advance Payment"
                  id="advancePayment"
                  value={FormData.advancePayment}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="space-y-3">
              <div className="grid grid-col-1 lg:grid-cols-3 gap-2">
                <div>
                  <label className="text-xs" htmlFor="">
                    Number of Rooms
                  </label>
                  <input
                    type="number"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Rooms"
                    id="rooms"
                    value={FormData.rooms}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Number of Floors
                  </label>
                  <input
                    type="number"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Floors"
                    id="floors"
                    value={FormData.floors}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Founded Year
                  </label>
                  <select
                    id="foundedYear"
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  >
                    <option value="">Select Year</option>
                    {Array.from({ length: 100 }, (_, i) => {
                      const year = new Date().getFullYear() - i;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="flex flex-wrap justify-start lg:justify-center items-center gap-2">
                <div>
                  <div>
                    <label className="text-xs" htmlFor="">
                      Property Star
                    </label>

                    <select
                      id="propertyStar"
                      onChange={handleChange}
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      value={FormData.propertyStar}
                    >
                      <option value="">Select Star</option>

                      {Array.from({ length: 5 }, (_, i) => i + 1).map(
                        (star) => (
                          <option key={star} value={star}>
                            {star.length > 1 ? `${star} Star` : `${star} Stars`}
                          </option>
                        ),
                      )}
                    </select>
                  </div>
                  <div className="flex justify-center items-center gap-2">
                    <div className="flex gap-1">
                      <div>
                        <label className="text-xs" htmlFor="">
                          CheckIn
                        </label>
                        <input
                          type="time"
                          className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                          id="checkIn"
                          value={FormData.checkIn}
                          onChange={handleChange}
                        />
                      </div>
                      <div>
                        <label className="text-xs" htmlFor="">
                          CheckOut
                        </label>
                        <input
                          type="time"
                          className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                          id="checkOut"
                          value={FormData.checkOut}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="">
                  <label className="text-xs" htmlFor="">
                    Hotel Logo
                  </label>
                  <div className="relative w-full h-20">
                    <img
                      className="w-full h-20 object-cover rounded-lg"
                      src={
                        FormData.hotelLogo
                          ? FormData.hotelLogo
                          : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                      }
                      alt=""
                    />
                    {FormData.hotelLogo && (
                      <div
                        onClick={() => handleRemoveImage("hotelLogo")}
                        className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                      >
                        <p className="text-xs">Remove</p>
                      </div>
                    )}
                    <div
                      onClick={() => handleUpload("hotelLogo")}
                      className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-full h-20"
                    >
                      <p className="font-bold text-[10px] text-white text-center">
                        Upload Now
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Facilities</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-2 gap-3">
            <div>
              <div className="text-sm text-center">
                <p>Create Facility</p>
              </div>
              <div>
                <div>
                  <div>
                    <label className="text-xs" htmlFor="">
                      Facility For
                    </label>

                    <div className="flex gap-x-3">
                      <input
                        type="text"
                        className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                        placeholder="Facility For"
                        value={SelectedFacility.useFor}
                        onChange={handleUseForChange}
                      />
                      <AddButton
                        onClick={handleSelectedFacility}
                        text="Add Now"
                        size="sm"
                      />
                    </div>
                  </div>

                  <div>
                    {FacilityData && (
                      <div className="py-2 flex gap-2 flex-wrap">
                        {FacilityData.map((item, index) => {
                          const isSelected = SelectedFacility.facilities.some(
                            (f) => f.facilityId === item.id,
                          );

                          return (
                            <div key={index}>
                              <div
                                onClick={() => handleSelectFacilities(item)}
                                className={`flex justify-start items-center gap-x-2 border w-fit p-1 rounded-lg cursor-pointer transition 
            ${isSelected ? "bg-blue-100 border-blue-500" : "border-gray-300"}
          `}
                              >
                                <div className="w-5 h-5 overflow-hidden rounded-lg">
                                  <img
                                    className="w-full h-full object-cover"
                                    src={item.icon}
                                    alt={item.facilityName}
                                  />
                                </div>

                                <p className="text-xs">{item.facilityName}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-center">Selected Facilities</p>
              </div>
              <div>
                {FormData.facilities.length > 0 ? (
                  <>
                    <div className="space-y-3">
                      {FormData.facilities.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="border space-y-3 p-4 rounded-lg relative"
                          >
                            <div>
                              <p className="text-sm font-semibold">
                                {item.useFor}
                              </p>
                            </div>
                            <div className="flex justify-start items-end flex-wrap gap-3">
                              {item.facilities.map((facility, index) => {
                                return (
                                  <div key={index}>
                                    <div className="flex justify-start items-center gap-x-2 border w-fit p-2 rounded-lg">
                                      <div className="w-5 h-5 overflow-hidden rounded-lg">
                                        <img
                                          className="w-full h-full object-cover"
                                          src={facility.icon}
                                          alt={facility.facilityName}
                                        />
                                      </div>

                                      <p className="text-xs">
                                        {facility.facilityName}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                            <div className="absolute -top-2 right-1 flex gap-x-1">
                              <EditButton
                                onClick={() => handleFacilityEdit(item)}
                              />
                              <DeleteButton
                                onClick={() => handleFacilityDelete(item)}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <div className="py-10 flex justify-center items-center">
                    <p className="text-sm text-black/50">
                      No Facilities Selected
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Near by places</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-2 gap-5">
            <div>
              <div>
                <p className="text-sm text-center">Add Near by place</p>
              </div>
              <div className="space-y-3">
                <div>
                  <label className="text-xs" htmlFor="">
                    Place Name
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Place Name"
                    id="placeName"
                    value={SelectNearBy.placeName}
                    onChange={handleNearByChange}
                  />
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Description
                  </label>
                  <textarea
                    type="text"
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Description"
                    id="description"
                    value={SelectNearBy.description}
                    onChange={handleNearByChange}
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs" htmlFor="">
                      Distance
                    </label>
                    <input
                      type="number"
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Distance"
                      id="distance"
                      value={SelectNearBy.distance}
                      onChange={handleNearByChange}
                    />
                  </div>
                  <div>
                    <label className="text-xs" htmlFor="">
                      Neighbourhood
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Neighbourhood"
                      id="neighbourhood"
                      value={SelectNearBy.neighbourhood}
                      onChange={handleNearByChange}
                    />
                  </div>
                </div>
                <div className="">
                  <label className="text-xs" htmlFor="">
                    Place Image
                  </label>
                  <div className="relative w-52 h-40">
                    <img
                      className="w-52 h-40 object-cover rounded-lg"
                      src={
                        SelectNearBy.image
                          ? SelectNearBy.image
                          : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                      }
                      alt=""
                    />
                    {SelectNearBy.image && (
                      <div
                        onClick={() => handleRemoveImage("image")}
                        className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                      >
                        <p className="text-xs">Remove</p>
                      </div>
                    )}
                    <div
                      onClick={() => handleUpload("image")}
                      className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-52 h-40"
                    >
                      <p className="font-bold text-[10px] text-white text-center">
                        Upload Now
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end lg:justify-center items-center gap-x-2">
                  <CancelButton text="Clear" size="sm" />
                  <AddButton
                    onClick={handleSelectedNearBy}
                    text="Add Now"
                    size="sm"
                  />
                </div>
              </div>
            </div>
            <div>
              <div>
                <p className="text-sm text-center">Selected Near by place</p>
              </div>
              <div>
                <div>
                  {FormData.nearBy.length > 0 ? (
                    <>
                      <div className="space-y-3">
                        {FormData.nearBy.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="p-2 rounded-lg border relative"
                            >
                              <div className="flex  gap-x-5">
                                <div className="w-40 h-full overflow-hidden rounded-lg">
                                  <img
                                    className="w-full h-full object-cover"
                                    src={item.image}
                                    alt=""
                                  />
                                </div>
                                <div className="space-y-2">
                                  <p className="text-md font-bold">
                                    {item.placeName}
                                  </p>
                                  <p className="text-sm text-black/60">
                                    {item.description}
                                  </p>
                                  <p className="text-xs text-black/50">
                                    Distance: {item.distance}
                                  </p>
                                  <p className="text-xs text-black/50">
                                    Neighbourhood: {item.neighbourhood}
                                  </p>
                                </div>
                                <div className="absolute top-2 right-2 flex gap-x-1">
                                  <EditButton
                                    onClick={() => handleEditNearByPlaces(item)}
                                  />
                                  <DeleteButton
                                    onClick={() =>
                                      handleRemoveNearbyPlaces(item.placeName)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  ) : (
                    <div className="py-10 flex justify-center items-center">
                      <p className="text-sm text-black/50">
                        No Near by place Selected
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Features Toggle</p>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-4">
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Couple Friendly?
              </label>
              <div>
                <Switch
                  checked={FormData.isCoupleFriendly === 1}
                  onChange={() => handleChangeFeatures("isCoupleFriendly")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Featured?
              </label>
              <div>
                <Switch
                  checked={FormData.isFeatured === 1}
                  onChange={() => handleChangeFeatures("isFeatured")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                ID card required?
              </label>
              <div>
                <Switch
                  checked={FormData.isIdRequired === 1}
                  onChange={() => handleChangeFeatures("isIdRequired")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Children allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isChildAllowed === 1}
                  onChange={() => handleChangeFeatures("isChildAllowed")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Pet allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isPetAllowed === 1}
                  onChange={() => handleChangeFeatures("isPetAllowed")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Mastercard allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isAcceptMasterCard === 1}
                  onChange={() => handleChangeFeatures("isAcceptMasterCard")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Visa allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isAcceptVisaCard === 1}
                  onChange={() => handleChangeFeatures("isAcceptVisaCard")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Cash allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isAcceptCash === 1}
                  onChange={() => handleChangeFeatures("isAcceptCash")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                MFS allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isAcceptsMFS === 1}
                  onChange={() => handleChangeFeatures("isAcceptsMFS")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Ammex Card allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isAcceptAmmexCard === 1}
                  onChange={() => handleChangeFeatures("isAcceptAmmexCard")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Debit Card allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isAcceptDebitCard === 1}
                  onChange={() => handleChangeFeatures("isAcceptDebitCard")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Dhoorbin choice?
              </label>
              <div>
                <Switch
                  checked={FormData.isDhoorbinChoice === 1}
                  onChange={() => handleChangeFeatures("isDhoorbinChoice")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Customer Choice allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isCustomerChoice === 1}
                  onChange={() => handleChangeFeatures("isCustomerChoice")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Select Images</p>
          </div>
          <div>
            {FormData.images.length > 0 ? (
              <>
                <div className="flex justify-start flex-wrap items-center gap-3">
                  {FormData.images.map((item, index) => {
                    return (
                      <div key={index} className="relative w-28 h-28">
                        <img
                          className="w-28 h-28 object-cover rounded-lg"
                          src={
                            item.imageLink ||
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                          }
                          alt=""
                        />
                        {item.imageLink && (
                          <div
                            onClick={() =>
                              handleRemoveImageLink(item.imageLink)
                            }
                            className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                          >
                            <p className="text-xs">Remove</p>
                          </div>
                        )}
                        <div
                          onClick={() => handleUpload("tin")}
                          className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-28 h-28"
                        >
                          <p className="font-bold">Upload Now</p>
                        </div>
                      </div>
                    );
                  })}
                  <div>
                    <button
                      onClick={handleUploadMulti}
                      className="p-4 border w-28 h-28 flex justify-center items-center text-2xl font-bold bg-white rounded-lg hover:bg-[#d3e8ff] duration-300"
                    >
                      +
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div>
                  <button
                    onClick={handleUploadMulti}
                    className="p-4 border w-28 h-28 flex justify-center items-center text-2xl font-bold bg-white rounded-lg hover:bg-[#d3e8ff] duration-300"
                  >
                    +
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3 ">
          <div>
            <p className="font-bold text-center uppercase">
              Rules and Policies
            </p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-2 gap-4">
            <div>
              <label htmlFor="" className="text-sm">
                Hotel Rules and Regulation
              </label>
              <EditorJSSingle
                content={FormData.hotelRules}
                setContent={(newContent) =>
                  setFormData((prev) => ({ ...prev, hotelRules: newContent }))
                }
              />
            </div>
            {FormData.isChildAllowed === 1 && (
              <div>
                <label htmlFor="" className="text-sm">
                  Chidren Policy
                </label>
                <EditorJSSingle
                  content={FormData.childPolicy}
                  setContent={(newContent) =>
                    setFormData((prev) => ({
                      ...prev,
                      childPolicy: newContent,
                    }))
                  }
                />
              </div>
            )}
            {FormData.isPetAllowed === 1 && (
              <div>
                <label htmlFor="" className="text-sm">
                  Pet Policy
                </label>
                <EditorJSSingle
                  content={FormData.petPolicy}
                  setContent={(newContent) =>
                    setFormData((prev) => ({ ...prev, petPolicy: newContent }))
                  }
                />
              </div>
            )}
          </div>
        </div>

        <div className="p-4 bg-white rounded-lg space-y-3">
          <div className="flex justify-center items-center gap-3">
            <AddButton onClick={handleSubmit} text="Add New Hotel" />
            <CancelButton text="Reset" />
          </div>
        </div>
      </div>
    </>
  );
};

export default DuplicateHotel;
